<template>
  <div class="panelContent" :style="{ backgroundColor: overrideBackgroundColour }">
    <div class="row center-xs">
      <div class="col-xs-12 mar-b20" v-if="panel.title && panel.title.text">
        <div :style="{'width': '100%', 'font-size': panel.autofit ? (panel.width * 0.5) + 'vw' : panel.title.size + 'px', color: panel.title.colour}">{{panel.title.text}}</div>
      </div>
      <div class="col-xs-12">
        <div :style="{ width: '100%', 'font-size': panel.autofit ? (1.5 * panel.width) + 'vw' : panel.content.size + 'px', color: overrideColour || panel.content.colour}">{{data}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import alarmChecker from "../../../utils/alarms";
import moment from "moment";
export default {
  props: ["panel", "data"],
  data() {
    return {
      overrideBackgroundColour: "",
      overrideColour: "",
      pulseTimer: undefined
    };
  },
  methods: {
    checkAlarms() {
      let triggered;
      if (this.panel.alarms && this.panel.alarms.length) {
        this.panel.alarms.forEach(alarm => {
          if (triggered) return;
          if (alarmChecker.check(alarm, null, moment(this.data, "HH:mm:ss").diff(moment().startOf("day"), "seconds"))) triggered = alarm;
        });
      }
      if (triggered) {
        this.overrideBackgroundColour = triggered.backgroundColour;
        this.overrideColour = triggered.colour;
        if (triggered.pulse) {
          let loop = false;
          this.pulseTimer = setInterval(() => {
            if (loop) {
              this.overrideBackgroundColour = triggered.backgroundColour;
              this.overrideColour = triggered.colour;
            } else {
              this.overrideBackgroundColour = "";
              this.overrideColour = "";
            }
            loop = !loop;
          }, 1000);
        }
      } else {
        if (this.pulseTimer) clearInterval(this.pulseTimer);
        this.overrideBackgroundColour = "";
        this.overrideColour = "";
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler: function(val, oldVal) {
        this.checkAlarms();
      }
    }
  }
};
</script>

<style>
</style>
